const severityMap = {
  LOW: {
    error: 'lowAlerts',
    color: 'primary.dark',
    border: 'primary.200',
  },
  MINOR: {
    error: 'minorAlerts',
    color: 'warning.dark',
    border: 'warning.main',
  },
  MAJOR: {
    error: 'majorAlerts',
    color: 'error.main',
    border: 'error.light',
  },
  CRITICAL: {
    error: 'criticalAlerts',
    color: 'error.dark',
    border: 'error.light',
  },
} as const;

export function getErrorSeverity(severity: string) {
  return severityMap[severity as keyof typeof severityMap];
}
